import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { getQuestionsById, getToken, updateQuestionsById } from "../services/api";
import { useParams } from "react-router-dom";
import "../styles/form.css";

const DynamicForm = () => {
    const [questions, setQuestions] = useState([]);
    const [formData, setFormData] = useState({}); // Estado para almacenar los valores de los campos
    const [Available, setAvailable] = useState(true);
    const [isClient, setIsClient] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        const fetchQuestions = async () => {
            const token = await getToken("syso.santiago", "Santiago1103");
            if (token) {
                sessionStorage.setItem("token", token);
                const { dataQuestions, isClient } = await getQuestionsById(id);
                setIsClient(isClient);
                if (dataQuestions?.length > 0) {
                    setQuestions(
                        dataQuestions.map((item) => ({
                            id: item[0],
                            type: item[1],
                            title: item[2],
                            options: item[3],
                            encTitle: item[4],
                            idRb: item[5],
                        }))
                    );
                    setAvailable(true);
                } else {
                    setAvailable(false);
                }
            }
        };
        fetchQuestions();
    }, []);

    const handleChange = (event, question) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            [question?.idRb]: value, // Actualiza el estado del campo correspondiente
        });
    };

    const handleRadioChange = (event, question) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            [question?.idRb]: value, // Actualiza el valor del radio button seleccionado
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("Formulario enviado:", formData);
        try {
            // Llamamos a la API para actualizar las preguntas
            await updateQuestionsById(id, formData,isClient);
            alert("Formulario actualizado correctamente.");
            window.location.href = "https://sysoempresarial.com/";
        } catch (error) {
            alert("Hubo un error al actualizar el formulario.");
            console.error(error);
        }
    };

    const renderField = (question) => {
        switch (question.type) {
            case "input":
                return (
                    <input
                        type="text"
                        name={question.id}
                        className="form-input"
                        placeholder={question.title}
                        value={formData[question?.idRb] || ""}
                        onChange={(e) => handleChange(e, question)}
                    />
                );
            case "date":
                return (
                    <input
                        type="date"
                        name={question.id}
                        className="form-input"
                        value={formData[question?.idRb] || ""}
                        onChange={(e) => handleChange(e, question)}
                    />
                );
            case "email":
                return (
                    <input
                        type="email"
                        name={question.id}
                        className="form-input"
                        placeholder={question.title}
                        value={formData[question?.idRb] || ""}
                        onChange={(e) => handleChange(e, question)}
                    />
                );
            case "radio":
                return (
                    <div className="radio-group">
                        {question.options.split(",").map((option) => (
                            <div key={option} className="radio-option">
                                <input
                                    type="radio"
                                    name={question.id}
                                    value={option}
                                    className="radio-input"
                                    required
                                    checked={formData[question?.idRb] === option}
                                    onChange={(e) => handleRadioChange(e, question)}
                                />
                                <span className="radio-label">{option}</span>
                            </div>
                        ))}
                    </div>
                );
            case "select":
                return (
                    <select
                        name={question.id}
                        className="form-select"
                        value={formData[question?.idRb] || ""}
                        required
                        onChange={(e) => handleChange(e, question)}
                    >
                        <option value="" disabled>Seleccionar...</option> {/* Opción vacía obligatoria */}
                        {question.options.split(",").map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                );
            case "text-area":
                return (
                    <textarea
                        name={question.id}
                        className="form-textarea"
                        placeholder={question.title}
                        value={formData[question.idRb] || ""}
                        onChange={(e) => handleChange(e, question)}
                    ></textarea>
                );
            default:
                return null;
        }
    };

    return (
        <Layout>
            {Available ? (
                <h1 className="form-title">{questions[0]?.encTitle || "Cargando..."}</h1>
            ) : <h1 className="form-title">{"NO DISPONIBLE!"}</h1>}
            <form className="form-container" onSubmit={handleSubmit}>
                {questions.map((question) => (
                    <div key={question.id} className="form-group">
                        <label className="form-label">{question.title}</label>
                        {renderField(question)}
                    </div>
                ))}
                {Available ? (
                    <button type="submit" className="submit-button">
                        Enviar
                    </button>
                ) : null}
            </form>
        </Layout>
    );
};

export default DynamicForm;